import { Api } from 'lib/api.mjs';
import { activityQuery } from 'lib/activity.mjs';

/** The activity log — budget changes and campaign/ad toggles, timestamped. */

/**
 * The query string is built by lib/activity.mjs, which also owns the page size
 * the pager reads back. Spelling it again here would let the two drift.
 *
 * @param {{ offset?: number, type?: string, search?: string,
 *           signal?: AbortSignal }} [payload]
 */
export function getActivity({ offset = 0, type = '', search = '', signal } = {}) {
  return Api.get(`/activity?${activityQuery({ offset, type, search })}`, { signal });
}
